export default "__VITE_ASSET__7fcb8c75__"